export enum AuctionTypeEnum {
  Bidding = 'bidding',
  BiddingWithBuyNow = 'biddingWithBuyNow',
  BuyNow = 'buyNow',
}
